import { render, staticRenderFns } from "./MultiSelectCrm.vue?vue&type=template&id=4b4c9ede"
import script from "./MultiSelectCrm.vue?vue&type=script&lang=js"
export * from "./MultiSelectCrm.vue?vue&type=script&lang=js"
import style0 from "./MultiSelectCrm.vue?vue&type=style&index=0&id=4b4c9ede&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports